import { QueryOperator, UseQueryModalReturn } from "../../types";

interface UseDateTimeQueryModalParams {
  operator?: QueryOperator | null;
  isValid?: boolean | null;
}

// TODO: add more logic with previous value and operator - VL-5552
export function useDateTimeQueryModal({
  operator,
  isValid,
}: UseDateTimeQueryModalParams): UseQueryModalReturn {
  const isSubmitDisabled = !operator || !isValid;

  return { isSubmitDisabled };
}
